// extracted by mini-css-extract-plugin
module.exports = {"StagesList":"StagesList_StagesList__3a6I7","title":"StagesList_title__2SWHR","brackets":"StagesList_brackets__K9G98","round":"StagesList_round__1klsX"};